import { create as createClient } from "axios";
import { CONFIG } from "@/modules/auth/constant/config";
import { errorHandler } from "../middleware/error-handler";

export const DefaultClient = createClient({
  baseURL: `${CONFIG.BASE_URL}/api/${CONFIG.VERSION}`,
});

DefaultClient.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

DefaultClient.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error)
);
